

// =====================================
//	確認視窗
//	@author: Alan
//	@time 2015 / 12 / 29
// =====================================

window.InifECApp.directive('confirmWithCheckbox', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            var submit = function() {
                ($scope.callback) && $scope.callback(true, $scope.isChecked);
                closeModal();
            }

            var cancel = function() {
                ($scope.callback) && $scope.callback(false);
                closeModal();
            }

            var toggleCheck = function(){
            	$scope.isChecked = !$scope.isChecked;
            }

            // ===============================
            //  開啟 modal
            // ===============================
            var openModal = function() {
            	$ngModal.openModal('confirm-with-checkbox-modal');
            }

            // ===============================
            //  關閉 modal
            // ===============================
            var closeModal = function() {
            	$ngModal.closeModal('confirm-with-checkbox-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_CONFIRM_WITH_CHECKBOX_MODAL', function(event, data) {
                if(data) {
                    $scope.title = data.title;
                    $scope.description = data.description;
                    $scope.checkDescript = data.checkDescript;
            		$scope.isChecked = data.isChecked;
                    $scope.callback = data.callback;
                }
            	openModal();
            });

            /*==========================
                Members
            ==========================*/
            $scope.title = undefined;
            $scope.description = undefined;
            $scope.checkDescript = undefined;
            $scope.isChecked = false;

            /*==========================
                Methods
            ==========================*/
            $scope.openModal = openModal;
            $scope.closeModal = closeModal;
            $scope.submit = submit;
            $scope.cancel = cancel;
            $scope.toggleCheck = toggleCheck;
            $scope.callback;

            
            /*==========================
                init
            ==========================*/

		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "partials/modal/confirm_with_checkbox.html";
		_dir.controller = controller;

		return _dir;
	}]
);